import decisioningOSLogo from "../images/nav-decisioning-os.svg"

export default [
  { to: "/decisioningos", text: "DecisioningOS", icon: decisioningOSLogo },
  { to: "/#solutions-section", text: "Solutions" },
  { to: "/about", text: "About Us" },
  { to: "/case-studies", text: "Case Studies" },
  { to: "/press", text: "Press" },
  { to: "/careers", text: "Careers" },
  { to: "https://app.inpwrd.com/", text: "Log In" },
  { to: "/#request-demo", text: "Request a Demo", isButton: true },
]
